"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = _interopRequireDefault(require("../../../icon/Icon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var MultiValueRemove = function MultiValueRemove(_ref) {
  var data = _ref.data,
    _onClick = _ref.innerProps.onClick;
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    className: "selected-item-icon",
    icon: "ion-android-delete",
    size: 14,
    "aria-label": "Remove item",
    onClick: function onClick() {
      return _onClick(data.value);
    }
  });
};
MultiValueRemove.propTypes = {
  data: _propTypes["default"].shape({}).isRequired,
  innerProps: _propTypes["default"].shape({}).isRequired
};
var _default = exports["default"] = MultiValueRemove;